import PhoneIcon from "@mui/icons-material/Call";
import { SxProps, Theme } from "@mui/material";
import Button, { ButtonProps } from "@mui/material/Button";

const PhoneButton = ({
  href,
  sx,
  ...props
}: ButtonProps & { sx?: SxProps<Theme> }) => (
  <Button
    href={href}
    color="secondary"
    variant="contained"
    disableElevation={true}
    sx={{
      alignSelf: "center",
      p: 1.25,
      mr: 1,
      minWidth: "initial",
      ...sx,
    }}
    size="small"
    aria-label="call"
    {...props}
  >
    <PhoneIcon sx={{ fontSize: "1.25rem" }} />
  </Button>
);

export default PhoneButton;
